export const fields = {
  firstName: {
    label: "First name*",
    name: "firstName",
    type: "text",
    placeholder: "First name*",
    title:
      "*The First Name field must be more than 2 and less than 20 characters",
    required: true,
  },
  lastName: {
    label: "Last name*",
    name: "lastName",
    type: "text",
    placeholder: "Last name*",
    title:
      "*The Last Name field must be more than 2 and less than 20 characters",
    required: true,
  },
  emailAddress: {
    label: "Email address*",
    name: "emailAddress",
    type: "text",
    placeholder: "Email address*",
    title: "*Enter a valid email",
    required: true,
  },
  phoneNumber: {
    label: "Phone number*",
    name: "phoneNumber",
    type: "tel",
    placeholder: "Phone number*",
    title: "*Enter a valid phone number",
    required: true,
  },
  address: {
    label: "Address*",
    name: "address",
    type: "text",
    placeholder: "Address*",
    title: "*The Address field must be more than 2 characters",
    required: true,
  },
  city: {
    label: "City*",
    name: "city",
    type: "text",
    placeholder: "City*",
    title: "*The City field must be more than 2 characters",
    required: true,
  },
  postCode: {
    label: "Post code*",
    name: "postCode",
    type: "text",
    placeholder: "Post code*",
    title: "*Enter your post code",
    required: true,
  },
  country: {
    label: "Country*",
    name: "country",
    type: "text",
    placeholder: "Country*",
    title: "*Enter your country",
    required: true,
  },
};
